import useEmblaCarousel from 'embla-carousel-react'
import { Container, DropdownItemProps, DropdownMenu, Stack, XStack } from '@my/ui'
import { useNextRouter } from 'app/hooks/use-next-router'
import { CategoryTabsItem } from './category-tabs-item'
import { CategoryTabsQueryOutput } from './queries'
import { useState } from 'react'
import { SecondaryNavigation } from 'app/components'
export interface CategoryTabsProps {
  loading: boolean
  categoryTabs: CategoryTabsQueryOutput['ArticleCategories']['docs']
}

const dropdownItems = [
  {
    label: 'Life',
    href: '/life',
  },
  {
    label: 'Chats',
    href: '/groups/feed',
  },
  {
    label: 'Discounts',
    href: '/student-discount',
  },
  {
    label: 'Freshers',
    href: '/freshers',
  },
]

export const CategoryTabs = (props: CategoryTabsProps) => {
  const [dropdownMenuOpen, setDropdownMenuOpen] = useState(false)
  const { asPath } = useNextRouter()
  const currentPath = asPath.endsWith('/') ? asPath.slice(0, -1) : asPath

  const [emblaRef] = useEmblaCarousel({
    slidesToScroll: 1,
    containScroll: 'keepSnaps',
    skipSnaps: true,
  })

  const getItemHref = (item: CategoryTabsQueryOutput['ArticleCategories']['docs'][0]) => {
    if (item.slug) {
      return `/life/categories/${item.slug}`
    }

    return '/life'
  }

  const allCategory: CategoryTabsQueryOutput['ArticleCategories']['docs'][0] = {
    id: '1',
    name: 'All',
    slug: '',
  }
  const categories = [allCategory, ...props.categoryTabs]

  return (
    <SecondaryNavigation>
      <Container fd="row" ai="center" size="base" gutter>
        <DropdownMenu
          open={dropdownMenuOpen}
          onOpenChange={setDropdownMenuOpen}
          initialItem={dropdownItems[0] as DropdownItemProps}
          items={dropdownItems}
          itemProps={{
            h: 36,
          }}
          contentProps={{
            top: -36,
            $gtSm: {
              display: 'none',
            },
          }}
          triggerProps={{
            h: 36,
            mr: '$2',
            $gtSm: {
              display: 'none',
            },
          }}
        />
        <Stack overflow="hidden" flex={1} ref={emblaRef as any}>
          <XStack height="auto">
            {categories.map((item) => {
              const href = getItemHref(item)
              const selected = currentPath === href

              return (
                <Stack
                  key={item.id}
                  minWidth={0}
                  flexGrow={0}
                  flexShrink={0}
                  pr="$2"
                  overflow="hidden"
                >
                  <CategoryTabsItem {...item} href={href} selected={selected} />
                </Stack>
              )
            })}
          </XStack>
        </Stack>
      </Container>
    </SecondaryNavigation>
  )
}
